import React from 'react';

const BienvenidaText = ({ text }) => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  }}>
    <h1 style={{ color: 'black', fontSize: '2rem' }}>{text}</h1>
  </div>
);

export default BienvenidaText;
